import React, { Component } from 'react';
import { Field, reduxForm, FormSection, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Form, Input, Tabs, message, Select, Modal, Checkbox } from 'antd';
import { BarLoader } from 'react-spinners';
import _ from 'lodash';
import { Collapse } from 'react-collapse';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import Dropzone from 'react-dropzone';

import MeNavBar from '../../components/MeNavBar';
import StatusControl from '../../components/StatusControl';
import Screenshot from '../../components/Screenshot';
import PriceControl from './PriceControl';
import CompanySection from './form-sections/CompanySection';
import ContactSection from './form-sections/ContactSection';
import DetailSection from './form-sections/DetailSection';
import {
  addProduct,
  fetchProductDetail,
  updateProduct
} from '../../actions/Product';

import {
  fetchAllCategories
} from '../../actions/CategoryActions';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
const TabPane = Tabs.TabPane;
const { confirm } = Modal;

class ProductCreate extends Component {

  constructor(props) {
    super(props);

    const { match, products } = props;
    const { productId } = match.params;

    this.priceControl = React.createRef();
    this.dropZoneRef = React.createRef();

    let editorState = null;
    if (productId) {
      const currentProduct = products[productId];

      editorState = processInitialContent(currentProduct);

      if (currentProduct) {
        // already have this product in memory
      } else {
        // fetch missing blog
        fetchProductDetail(productId, (updatedProduct) => {
          // async
          const updatedEditorState = processInitialContent(updatedProduct);
          this.setState({ editorState: updatedEditorState });
        });
      }
    } else {
      editorState = processInitialContent();
    }

    this.state = {
      fileList: [],
      previewVisible: false,
      previewImage: '',
      status: 0,
      phones: [],
      activeTabKey: 'zh',
      editorState: editorState,
      screenshotFiles: [],
    }
  }

  onEditorStateChange(editorState, lang) {
    let updateState = { ...this.state.editorState };
    updateState[lang] = editorState;

    this.setState({ editorState: updateState });
  }

  onDrop(newFiles) {
    const screenshots = this.state.screenshotFiles.slice();
    screenshots.push(...newFiles);

    this.setState({ screenshotFiles: screenshots });
    console.log(screenshots);
  }

  onChooseFileClick() {
    this.dropZoneRef.open();
  }

  static getDerivedStateFromProps(nextProps, prevState) {

    const { productId } = nextProps.match.params;
    const product = nextProps.products[productId];

    if (product && product.image_paths) {
      // create fileList
      const fileList = _.map(product.image_paths, (imagePath, key) => {
        return {
          preview: imagePath.thumb_url,
          lastModified: Math.random(),
          imageId: key,
        };
      });
      return { screenshotFiles: fileList, status: product.status };
    }
    return null;
  }

  componentDidMount() {

    const { match: { params }, categories, products, fetchProductDetail, fetchAllCategories } = this.props;
    const { productId } = params;
    const product = products[productId];

    if (productId || (productId && !product)) {
      fetchProductDetail(productId);
    }
    if (categories.length === 0) {
      fetchAllCategories();
    }
  }

  onTabChange(key) {
    this.setState({ activeTabKey: key });
  }

  onStatusChange(status) {
    this.setState({ status: status });
  }

  handlePhoneNumberSubmit(value) {

    let phones = this.state.phones.slice();
    if (!phones.includes(value)) {
      phones.push(value);
      this.setState({ phones: phones });
    }
  }

  onScreenshotDelete(image) {
    console.log(image);
    confirm({
      title: 'Are you sure you want to delete this image?',
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => {
        console.log('OK');
        // perform delete
        //  remove this image from state.screenshotFiles
        if (image.imageId) {
          // remove from server
          this.performScreenshotDelete(image);
        } else {
          // local file, delete from state
          const newScreenshots = this.state.screenshotFiles.slice();
          _.remove(newScreenshots, file => file.lastModified === image.lastModified);
          this.setState({ screenshotFiles: newScreenshots });
        }
      },
    });
  }

  performScreenshotDelete(image) {
    const { productId } = this.props.match.params;
    const hideLoading = message.loading('Deleting Image...', 0);

    // this.props.deleteScreenshot({
    //   appId,
    //   screenshotId: image.imageId,
    // }, activeUser.access_token, (error) => {
    //   hideLoading();

    //   if (error) {
    //     message.error('Error Deleting Screenshot', 2.5);
    //   } else {
    //     message.success('Screenshot Deleted', 2.5);

    //     const newScreenshots = this.state.screenshotFiles.slice();
    //     _.remove(newScreenshots, file => file.imageId === image.imageId);
    //     this.setState({ screenshotFiles: newScreenshots });
    //   }
    // });
  }

  submitForm(values) {

    const {
      status,
      editorState: { en, th, zh },
      screenshotFiles,
    } = this.state;

    console.log(screenshotFiles);

    // content
    let desc = {};
    if (en) {
      desc.en = JSON.stringify(convertToRaw(en.getCurrentContent()));
    }
    if (th) {
      desc.th = JSON.stringify(convertToRaw(th.getCurrentContent()));
    }
    if (zh) {
      desc.zh = JSON.stringify(convertToRaw(zh.getCurrentContent()));
    }

    const priceSet = this.priceControl.current.getPrice();
    let updateValues = {
      ...values,
      desc: desc,
      prices: priceSet,
      name_en: values.pname_en,
      name_th: values.pname_th,
      name_zh: values.pname_zh,
      status: status
    };

    delete updateValues.pname_en;
    delete updateValues.pname_th;
    delete updateValues.pname_zh;

    console.log(updateValues);

    const { match: { params }, history } = this.props;
    const { productId } = params;

    console.log(params);

    const hideLoading = message.loading('Saving Product', 0);

    if (productId) {
      // update
      this.props.updateProduct({
        product: updateValues,
        id: productId,
        imageFiles: screenshotFiles,
      }, (uploadingFile, progress) => {
        // progress callback

      }, (error) => {
        // finish callback
        hideLoading();

        if (error) {
          message.error('Error saving product!');
        } else {
          message.success('Product has been updated!');
          history.push('/products');
        }
      });
    } else {
      // create
      this.props.addProduct(updateValues, screenshotFiles, (uploadingFile, progress) => {
        // image upload progress

      }, (error) => {
        hideLoading();

        if (error) {
          message.error('Error saving product!');
        } else {
          message.success('Product has been created!');
          history.push('/products');
        }
      });
    }
  }

  renderEditor(editorState, { lang, title }) {
    return (
      <div style={{ paddingBottom: 14 }}>
        <label className="ant-form-item-required">{title}</label>
        <Editor
          editorState={editorState[lang]}
          toolbarClassName="rdw-storybook-toolbar"
          // wrapperClassName="form-group txt-area"
          editorClassName="form-control"
          onEditorStateChange={(editorState) => this.onEditorStateChange(editorState, lang)}
          toolbar={{
            options: ['inline', 'blockType', 'list', 'textAlign', 'link', 'embedded', 'image', 'history'],
            inline: {
              inDropdown: false,
              options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace']
            },
            image: { uploadCallback: uploadImageCallBack, alt: { present: false, mandatory: false } },
          }}
        />
      </div>
    );
  }

  renderProductSelection() {
    return (
      <div>
        <div className="divider"></div>
        <div className="products-in-set">
          <h5>Products in Set</h5>
          <table className="table teble-products-in-set">
            <thead>
              <tr>
                <th scope="col">Product</th>
                <th scope="col">Amount</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <div className="dropdown form-dropdown">
                    <button className="btn dropdown-toggle form-list" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Please select Product
                                            </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <li>
                        <a className="dropdown-item" href="#">Fish Oil</a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">Fish Oil</a>
                      </li>
                    </ul>
                  </div>
                </th>
                <td>
                  <input type="text" placeholder="0" />
                </td>
                <td>Remove</td>
              </tr>
              <tr>
                <th scope="row">
                  <div className="dropdown form-dropdown">
                    <button className="btn dropdown-toggle form-list" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Please select Product
                                            </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <li>
                        <a className="dropdown-item" href="#">Fish Oil</a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">Fish Oil</a>
                      </li>
                    </ul>
                  </div>
                </th>
                <td><input type="text" placeholder="0" /></td>
                <td>Remove</td>
              </tr>
            </tbody>
          </table>
          <div className="form-group add-more-btn">
            <img src="/resources/img/ic-add.png" alt="" />
            <label>Add More</label>
          </div>
        </div>
      </div>
    );
  }

  renderField(field) {
    const { meta: { touched, error }, input } = field;
    const className = `input-txt`;
    const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
    const help = `${touched && error ? error : ''}`;

    return (
      <FormItem
        label={field.label}
        colon
        className={className}
        validateStatus={validationStatus}
        help={help}
        hasFeedback={field.required}
        required={field.required}
      >
        <Input
          className="form-control"
          placeholder={field.placeholder}
          size="large"
          {...input}
          type="text"
          addonBefore={field.addonBefore}
        />
      </FormItem>
    );
  }

  renderWeightField() {
    const className = `form-group input-txt`;
    const weightComponent = (field) => {
      return (
        <div>
          <Input  {...field.input} style={{ flex: 1, paddingRight: 5 }} type="number" placeholder="0.0" addonBefore="Kg" />
        </div>
      );
    };

    return (
      <FormSection name="package_weight">
        <FormItem
          label={'Package Weight (Kilograms):'}
          colon
          className={className}
        >
          <div style={{ display: 'flex' }}>
            <Field
              name="weight"
              component={weightComponent}
            />
          </div>
        </FormItem>
      </FormSection>
    );
  }

  renderDimensionField() {
    const className = `form-group input-txt`;
    // const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
    // const help = `${touched && error ? error : ''}`;

    const widthComponent = (field) => {
      return (
        <div>
          <Input  {...field.input} style={{ flex: 1, paddingRight: 5 }} type="number" placeholder="width" addonBefore="Width" />
        </div>
      );
    };
    const lengthComponent = (field) => {
      return (
        <div>
          <Input {...field.input} style={{ flex: 1, paddingLeft: 5, paddingRight: 5 }} type="number" placeholder="length" addonBefore="Length" />
        </div>
      );
    };
    const heightComponent = (field) => {
      return (
        <div>
          <Input {...field.input} style={{ flex: 1, paddingLeft: 5 }} type="number" placeholder="height" addonBefore="Height" />
        </div>
      );
    };

    return (
      <FormSection name="package_dimension">
        <FormItem
          label={'Package Dimemsion (centimetre):'}
          colon
          className={className}
        // validateStatus={validationStatus}
        // help={help}
        // hasFeedback={field.required}
        // required={field.required}
        >
          <div style={{ display: 'flex' }}>
            <Field
              name="width"
              component={widthComponent}
            />
            <Field
              name="length"
              component={lengthComponent}
            />
            <Field
              name="height"
              component={heightComponent}
            />
          </div>
          {/* <Input
                    className="form-control"
                    placeholder={field.placeholder}
                    size="large"
                    {...input}
                    type="number"
                    addonBefore={field.addonBefore}
                /> */}
        </FormItem>
      </FormSection>
    );
  }

  renderTextAreaField(field) {
    const { meta: { touched, error }, input } = field;
    const className = `form-group txt-area`;
    const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
    const help = `${touched && error ? error : ''}`;

    return (
      <FormItem
        label={field.label}
        colon
        className={className}
        required={field.required}
        validateStatus={validationStatus}
        help={help}
      >
        <TextArea
          className="form-control"
          placeholder={field.placeholder}
          autosize={{ minRows: 5, maxRows: 9 }}
          {...input}
        />
      </FormItem>
    );
  }

  renderSelectField(field) {
    const { meta: { touched, error }, input } = field;
    const className = `form-group select-dropdown`;
    const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
    const help = `${touched && error ? error : ''}`;

    const options = field.options.map((category, index) => {
      return <Option value={category.id} key={category.id}>{category.name_en}</Option>;
    });

    return (
      <FormItem
        label={field.label}
        colon
        className={className}
        required={field.required}
        validateStatus={validationStatus}
        hasFeedback={field.required}
        help={help}
      >
        <Select
          label={field.label}
          defaultActiveFirstOption={false}
          dropdownClassName="form-list"
          placeholder={field.placeholder}
          size="large"
          mode="multiple"
          {...input}
          onInputKeyDown={(e) => {
            if (e.keyCode === 13) {
              // Enter
              e.preventDefault();
            }
          }}
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {options}
        </Select>
      </FormItem>
    );
  }

  renderTagsField(field) {
    const { meta: { touched, error }, input } = field;
    const className = `form-group select-dropdown`;
    const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
    const help = `${touched && error ? error : ''}`;

    return (
      <FormItem
        label={field.label}
        colon
        className={className}
        required={field.required}
        validateStatus={validationStatus}
        hasFeedback={field.required}
        help={help}
      >
        <Select
          label={field.label}
          defaultActiveFirstOption={false}
          dropdownClassName="form-list"
          placeholder={field.placeholder}
          size="large"
          mode="tags"
          notFoundContent={field.placeholder}
          // onSelect={(value) => console.log(value)}
          {...input}
          // value={this.state.phones}
          onInputKeyDown={(e) => {
            if (e.keyCode === 13) {
              // Enter
              e.preventDefault();
              e.target.blur();
            }
          }}
          tokenSeparators={[',']}
        // filterOption={false}
        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        />
      </FormItem>
    );
  }

  renderCheckbox(field) {
    const { meta: { touched, error }, input } = field;
    const className = `form-group select-dropdown`;
    // const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
    // const help = `${touched && error ? error : ''}`;
    // console.log(input);

    return (
      <FormItem
        // label={field.label}
        colon
        className={className}
        required={field.required}
        // validateStatus={validationStatus}
        hasFeedback={field.required}
      // help={help}
      >
        <Checkbox {...input} checked={input.value} >{field.placeholder}</Checkbox>
      </FormItem>
    );
  }

  renderScreenshots(images) {
    const className = `upload-content ${images.length > 0 ? 'show-image' : ''}`;

    const screenshots = images.map((image) => {
      return (
        <Screenshot
          key={image.lastModified}
          src={image.preview}
          onDelete={() => this.onScreenshotDelete(image)}
        />
      );
    });

    const chooser = (
      <div className="drag-upload-info">
        <div className="upload-num">
          <p className="upload-num-text">{`${images.length} images`}</p>
        </div>
        <div className="choose-file-btn" onClick={this.onChooseFileClick.bind(this)}>
          <label>Choose File</label>
        </div>
      </div>
    );

    return (
      <div className="form-inner-drag-up">
        <Dropzone
          className="drop"
          onDrop={this.onDrop.bind(this)}
          ref={node => this.dropZoneRef = node}
          disableClick
        >
          {images.length > 0
            ? (
              <div className={className}>
                {screenshots}
                {chooser}
              </div>
            ) : (
              <div className={className}>
                <img className="cloud-upload" src="/resources/img/cloud-upload.svg" alt="" />
                <p className="drag-upload-text">Drag product images here</p>
                {chooser}
              </div>
            )
          }
        </Dropzone>
      </div>
    );
  }

  render() {

    const { activeTabKey, editorState, screenshotFiles } = this.state;
    const { location, handleSubmit, match: { params, path }, categories, isProductLoading, useCompanyInfo } = this.props;
    const { productId } = params;
    let isSet = false;
    let isCreate = false;

    const product = this.props.products[params.productId];

    switch (path) {
      case '/products/:productId':
        // edit
        break;
      case '/products/new':
        if (location.hash === '#set') {
          isSet = true;
        }
        isCreate = true;
        break;
      default:
        break;
    }

    if ((!isCreate && !productId) || (productId && !product)) {
      // not loaded
      return (
        <div className="container-fluid">
          <MeNavBar
            to={'/products'}
            title={`${isCreate ? 'New' : 'Edit'} - Product${isSet ? ' Set' : ''}`}
            hideButton
          />
          <div style={{ zIndex: 10, marginTop: 80 }}>
            <BarLoader loading={true} color={'#455963'} width={window.innerWidth} height={2} />
          </div>
        </div>
      );
    }

    return (
      <div className="detail-content-highlight">
        <form onSubmit={handleSubmit(this.submitForm.bind(this))}>
          <div className="container-fluid">
            <MeNavBar
              to={'/products'}
              title={`${isCreate ? 'New' : 'Edit'} - Product${isSet ? ' Set' : ''}`}
              buttonTitle={isCreate ? 'Add Product' : 'Save'}
            />
            <div className="form-body">
              <div className="form-content">
                <div className="name-sku">
                  <h5>{'Name & SKU'}</h5>
                  <div className="form-group txt-area has-tabs">
                    <Tabs activeKey={activeTabKey} onChange={this.onTabChange.bind(this)} animated={false} >
                      <TabPane
                        tab="Chinese"
                        key="zh"
                      >
                        <Field
                          name="pname_zh"
                          label="Product Name (ZH)"
                          placeholder="Product Name (Chinese)"
                          component={this.renderField}
                          required
                        />
                        <FormSection
                          name="brand"
                        >
                          <Field
                            name="zh"
                            label="Brand (ZH)"
                            placeholder="Brand (Chinese)"
                            component={this.renderField}
                          />
                        </FormSection>
                      </TabPane>
                      <TabPane
                        tab="English"
                        key="en"
                      >
                        <Field
                          name="pname_en"
                          label="Product Name (EN)"
                          placeholder="Product Name (English)"
                          component={this.renderField}
                        />
                        <FormSection
                          name="brand"
                        >
                          <Field
                            name="en"
                            label="Brand (EN)"
                            placeholder="Brand (English)"
                            component={this.renderField}
                          />
                        </FormSection>
                      </TabPane>
                      <TabPane
                        tab="Thai"
                        key="th"
                      >
                        <Field
                          name="pname_th"
                          label="Product Name (TH)"
                          placeholder="Product Name (Thai)"
                          component={this.renderField}
                        />
                        <FormSection
                          name="brand"
                        >
                          <Field
                            name="th"
                            label="Brand (TH)"
                            placeholder="Brand (Thai)"
                            component={this.renderField}
                          />
                        </FormSection>
                      </TabPane>
                    </Tabs>
                    <Field
                      name="sku"
                      label="SKU"
                      placeholder="SKU"
                      component={this.renderField}
                      required
                    />
                  </div>
                </div>
                <div className="divider" />

                <div className="category">
                  <h5>Categories</h5>
                  <Field
                    name="category_ids"
                    label="Categories"
                    placeholder="Select Categories"
                    component={this.renderSelectField}
                    options={categories}
                    defaultValue={product ? product.category_ids : []}
                    required
                  />
                </div>
                {isSet ? this.renderProductSelection() : null}
                <div className="divider" />

                <div className="description">
                  <h5>Detail</h5>
                  <div className="form-group has-tabs txt-area">
                    <Tabs activeKey={activeTabKey} onChange={this.onTabChange.bind(this)} animated={false} >
                      <TabPane
                        tab="Chinese"
                        key="zh"
                      >
                        <DetailSection
                          languageKey="zh"
                          textAreaComponent={this.renderTextAreaField}
                          fieldComponent={this.renderField}
                          contentEditor={this.renderEditor(editorState, { lang: 'zh', title: 'Content (ZH)' })}
                        />
                      </TabPane>

                      <TabPane
                        tab="English"
                        key="en"
                      >
                        <DetailSection
                          languageKey="en"
                          textAreaComponent={this.renderTextAreaField}
                          fieldComponent={this.renderField}
                          contentEditor={this.renderEditor(editorState, { lang: 'en', title: 'Content (EN)' })}
                        />
                      </TabPane>

                      <TabPane
                        tab="Thai"
                        key="th"
                      >
                        <DetailSection
                          languageKey="th"
                          textAreaComponent={this.renderTextAreaField}
                          fieldComponent={this.renderField}
                          contentEditor={this.renderEditor(editorState, { lang: 'th', title: 'Content (TH)' })}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                  {this.renderDimensionField()}
                  {this.renderWeightField()}
                </div>
                <div className="divider" />

                <div className="description">
                  <h5>Standards / Trademarks</h5>
                  <Field
                    label="Univeral Product Code (UPC)"
                    name="upc"
                    placeholder="UPC"
                    component={this.renderField}
                  />
                  <Field
                    label="FDA Number"
                    name="fda_number"
                    placeholder="FDA Number"
                    component={this.renderField}
                  />
                  <Field
                    label="Other Standards"
                    name="other_standards"
                    placeholder="Other Standards"
                    component={this.renderTextAreaField}
                  />
                  <Field
                    label="Trademarks"
                    name="trademarks"
                    placeholder="Trademarks"
                    component={this.renderTextAreaField}
                  />
                </div>
                <div className="divider" />

                <div className="description">
                  <h5>Company / Entrepreneur</h5>
                  <div className="form-group has-tabs txt-area">
                    <Tabs activeKey={activeTabKey} onChange={this.onTabChange.bind(this)} animated={false} >
                      <TabPane
                        tab="Chinese"
                        key="zh"
                      >
                        <CompanySection
                          sectionName="distributor"
                          languageKey="zh"
                          fieldComponent={this.renderField}
                        />
                      </TabPane>
                      <TabPane
                        tab="English"
                        key="en"
                      >
                        <CompanySection
                          sectionName="distributor"
                          languageKey="en"
                          fieldComponent={this.renderField}
                        />
                      </TabPane>
                      <TabPane
                        tab="Thai"
                        key="th"
                      >
                        <CompanySection
                          sectionName="distributor"
                          languageKey="th"
                          fieldComponent={this.renderField}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                  <ContactSection
                    sectionName="distributor"
                    fieldComponent={this.renderTagsField}
                  />
                </div>
                <div className="divider" />

                <div className="description">
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h5>Manufacturer</h5>
                    <Field
                      name="use_company_info"
                      component={(field) =>
                        <Checkbox
                          {...field.input}
                          checked={field.input.value}
                        >
                          {'Use Company Info'}
                        </Checkbox>
                      }
                    />
                  </div>
                  <Collapse isOpened={!useCompanyInfo}>
                    <div className="form-group has-tabs txt-area">
                      <Tabs activeKey={activeTabKey} onChange={this.onTabChange.bind(this)} animated={false} >
                        <TabPane
                          tab="Chinese"
                          key="zh"
                        >
                          <CompanySection
                            sectionName="manufacturer"
                            languageKey="zh"
                            fieldComponent={this.renderField}
                          />
                        </TabPane>
                        <TabPane
                          tab="English"
                          key="en"
                        >
                          <CompanySection
                            sectionName="manufacturer"
                            languageKey="en"
                            fieldComponent={this.renderField}
                          />
                        </TabPane>
                        <TabPane
                          tab="Thai"
                          key="th"
                        >
                          <CompanySection
                            sectionName="manufacturer"
                            languageKey="th"
                            fieldComponent={this.renderField}
                          />
                        </TabPane>
                      </Tabs>
                    </div>
                    <ContactSection
                      sectionName="manufacturer"
                      fieldComponent={this.renderTagsField}
                    />
                  </Collapse>

                </div>
                <div className="divider" />

                <div className="image">
                  <h5>Images</h5>
                  {this.renderScreenshots(screenshotFiles)}
                </div>
                <div className="divider" />

                <div className="image">
                  <h5>Video</h5>
                </div>
                <div className="divider" />

                <div className="price-list">
                  <h5>Prices</h5>
                  <PriceControl
                    ref={this.priceControl}
                    prices={product ? product.prices : null}
                  />
                </div>
                <div className="divider" />
                <div className="description">
                  <h5>Export</h5>
                  <Field
                    name="export_china"
                    label="Export to China"
                    placeholder="Export to China"
                    component={this.renderCheckbox}
                  />

                </div>
                <div className="divider" />

                <StatusControl
                  selectedStatus={this.state.status}
                  options={[
                    {
                      title: 'Ready For Sale',
                      desc: 'Display this product on website'
                    },
                    {
                      title: 'Out of Stock',
                      desc: 'Display this product as “Out of Stock” on website'
                    },
                    {
                      title: 'Removed From Sale',
                      desc: 'Hide this product on website'
                    }
                  ]}
                  onChange={this.onStatusChange.bind(this)}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

// default is Chinese
function validate(values) {
  const errors = {};

  if (!values.pname_zh) {
    errors.pname_zh = 'Product name cannot be empty';
  }
  if (!values.sku) {
    errors.sku = 'SKU cannot be empty';
  }
  if (!values.category_ids || values.category_ids.length === 0) {
    errors.category_ids = 'Product must have at least one category';
  }
  if (values.desc ? !values.desc.zh : false) {
    errors.desc.zh = 'Product must have description';
  }

  return errors;
}

function uploadImageCallBack(file) {

  // TODO: upload image files

}

function processInitialContent(product) {

  let editorStateEn = null;
  if (product && product.desc && product.desc.en) {
    try {
      const contentStateEn = convertFromRaw(JSON.parse(product.desc.en));
      editorStateEn = EditorState.createWithContent(contentStateEn);
    } catch (error) {
    }
  } else {
    editorStateEn = EditorState.createEmpty();
  }

  let editorStateTh = null;
  if (product && product.desc && product.desc.th) {
    try {
      const contentStateTh = convertFromRaw(JSON.parse(product.desc.th));
      editorStateTh = EditorState.createWithContent(contentStateTh);
    } catch (error) {
    }
  } else {
    editorStateTh = EditorState.createEmpty();
  }

  let editorStateZh = null;
  if (product && product.desc && product.desc.zh) {
    try {
      const contentStateZh = convertFromRaw(JSON.parse(product.desc.zh));
      editorStateZh = EditorState.createWithContent(contentStateZh);
    }
    catch (error) {
    }
  } else {
    editorStateZh = EditorState.createEmpty();
  }

  const editorState = {
    en: editorStateEn,
    th: editorStateTh,
    zh: editorStateZh
  };

  return editorState;
}

function mapStateToProps(state, ownProps) {
  const { products, isProductLoading } = state.product;
  const { categories, isCategoryLoading } = state.category;

  const { productId } = ownProps.match.params;
  const product = products[productId];

  let defaultVal = {};
  if (product) {

    let distributor = {
      phones: [],
      emails: [],
      websites: [],
    };
    if (product.distributor) {
      distributor = {
        ...product.distributor,
        phones: (product.distributor.phones ? product.distributor.phones : []),
        emails: (product.distributor.emails ? product.distributor.emails : []),
        websites: (product.distributor.websites ? product.distributor.websites : []),
      };
    }

    let manufacturer = {
      phones: [],
      emails: [],
      websites: [],
    };
    if (product.manufacturer) {
      manufacturer = {
        ...product.manufacturer,
        phones: (product.manufacturer.phones ? product.manufacturer.phones : []),
        emails: (product.manufacturer.emails ? product.manufacturer.emails : []),
        websites: (product.manufacturer.websites ? product.manufacturer.websites : []),
      };
    }

    defaultVal = {
      ...product,
      pname_en: product.name_en,
      pname_th: product.name_th,
      pname_zh: product.name_zh,
      distributor: distributor,
      manufacturer: manufacturer,
      export_china: product.export_china ? product.export_china : false,
      use_company_info: product.use_company_info ? product.use_company_info : false
    }
  } else {
    defaultVal = {
      pname_en: '',
      pname_th: '',
      pname_zh: '',
      category_ids: [],
      distributor: {
        phones: [],
        emails: [],
        websites: [],
      },
      manufacturer: {
        phones: [],
        emails: [],
        websites: [],
      },
      export_china: false,
      use_company_info: false
    }
  }

  return {
    products,
    isProductLoading,
    initialValues: defaultVal,
    categories,
    isCategoryLoading,
    useCompanyInfo: selector(state, 'use_company_info'),
  };
}

const selector = formValueSelector('ProductForm')

ProductCreate = reduxForm({
  validate,
  form: 'ProductForm',
  enableReinitialize: true
})(ProductCreate);

export default connect(mapStateToProps, {
  addProduct,
  fetchProductDetail,
  fetchAllCategories,
  updateProduct
})(ProductCreate);


// WEBPACK FOOTER //
// ./src/views/products/Create.js